import { AxiosResponse } from "axios";
import { axiosClient } from "../../axiosClient";
import { axiosSafeRequest } from "../../axiosSafeRequest";
import { Product } from "../../types";

type ApiResponse = AxiosResponse<Product[]>;

/**
 * Get a list of products for the current customer.
 *
 * @returns An HTTP response.
 */
export const apiProductIndexGet = async (): Promise<ApiResponse | undefined> => {
  return axiosSafeRequest(() => axiosClient.get(`/product`));
}
